<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import FormPersonalVerifyEmail from './form-personal-verify-email';

export default {
  name: 'page-personal-verify-email',
  mixins: [
    PageProps,
  ],
  props: {
    token: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    FormPersonalVerifyEmail,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    PersonalEmailVerify() {
      return this.$store.getters.PersonalEmailVerify;
    },
  },
  methods: {
    ...mapActions([
      'MakePersonalEmailVerify',
    ]),
    onSubmitForm(payload) {
      console.log('payload', payload);
    },
  },
  created() {
    return this.token ? this.MakePersonalEmailVerify({ payload: { token: this.token } })
      .then(() => {
        this.successNotification({ message: 'message.success_email_verified' });
        this.onCancelEvent();
      }).catch(() => {
        this.errorNotification({ message: 'message.error_email_verified' });
      }) : false;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/verify-email/page-personal-verify-email.vue